import { render, staticRenderFns } from "./fouth.vue?vue&type=template&id=7353ff34&scoped=true&"
import script from "./fouth.vue?vue&type=script&lang=js&"
export * from "./fouth.vue?vue&type=script&lang=js&"
import style0 from "./fouth.vue?vue&type=style&index=0&id=7353ff34&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7353ff34",
  null
  
)

export default component.exports